import { defineStore } from "pinia";
import { fetchPatient, savePatient } from '@/../../EshJSLib/services/schedaPaziente'
import { getFiles } from '@/../../EshJSLib/services/fileService'
import { getKardias } from '@/../../EshJSLib/services/kardiaServices'
import { getUrl } from '@/../../EshJSLib/services/fileServices'
import { getVaccini } from '@/../../EshJSLib/services/vaccinazioneServices'
import { getLinkPersonale } from '@/../../EshJSLib/services/linkPersonaleServices'
import { getEsamiType, getCentriIndagini } from '@/../../EshJSLib/services/esamiServices'
import { getAdverseReaction, getFarmaci, saveAdverseReaction, saveTerapia, fetchSecuritySettings } from '@/../../EshJSLib/services/farmaciServices';

import { Data, Diagnosi, PatientScore, ScoreResult, ScoringCalculator, Score, Consensi } from '@/../../EshJSLib/models/patient'
import PatientJson from '@/../../EshJSLib/models/sample/patient.json'
import { fetchDiagnosi } from '@/../../EshJSLib/services/diagnosiServices'
import { fetchVisite } from '@/../../EshJSLib/services/visiteServices'
import { fetchRilevazioni } from '@/../../EshJSLib/services/rilevazioniServices'

import { fetchAnamnesiFm, fetchAnamnesiRm, fetchAnamnesiPr, fetchAnamnesiFisiologica, fetchGravidanze } from '@/../../EshJSLib/services/anamnesiServices'
import { getAllScores, getFilteredTypePatientScores } from '@/../../EshJSLib/services/scoreServices'

import { getFilteredListScore, getFilteredCombinationList } from "@/../../EshJSLib/services/scoringCalculatorServices"
import { getEmergencyContact, getMoreContacts } from '@/../../EshJSLib/services/contactServices'
import { getTaccuino } from '@/../../EshJSLib/services/taccuinoService';
import { updateConsenso } from '@/../../EshJSLib/services/consensoService';
import { getAscDoctors,getNAdoctors } from '@/../../EshJSLib/services/cppServices';

interface State {
  patient: Data;
  collapsableStatus: Dictionary<string>
}

interface Dictionary<T> {
  [Key: string]: T;
}

export const patientStore = defineStore("patientStore", {
  state: () => (
    {
      patient: {} as Data,
      collapsableStatus: {} as Dictionary<boolean>,
      loginLogs: [],
    }),
  getters: {
    getPatient: (state) => state.patient,
    getCollapsableStatus: (state) => state.collapsableStatus
  },
  actions: {
    getPatientDetails: async function (patientId: number) {
      const patientobj = localStorage.getItem('patient')
      console.log(patientobj == null); console.log(patientobj == 'null');
      if (patientobj != 'null' && patientobj != null) {
        this.patient = JSON.parse(localStorage.getItem('patient'))
        console.log(this.patient);
      } else {
        const response = await fetchPatient(patientId)
        this.patient = response.data as Data
        localStorage.setItem('patient', JSON.stringify(this.patient))
      }
    },

    refreshScheda: async function (patientId: number) {
      const response = await fetchPatient(patientId);
      const data = response.data as Data;
      this.patient.paziente_nome = data.paziente_nome;
      this.patient.paziente_cognome = data.paziente_cognome;
      this.patient.paziente_codfiscale = data.paziente_codfiscale;
      this.patient.paziente_nascita = data.paziente_nascita;
      this.patient.paziente_sesso = data.paziente_sesso;
      this.patient.paziente_gruppo = data.paziente_gruppo;
      this.patient.paziente_donatore_organi = data.paziente_donatore_organi;
      this.patient.user.contact_detail.comune_nascita = data.user.contact_detail.comune_nascita;
      this.patient.user.contact_detail.comune_residenza = data.user.contact_detail.comune_residenza;
      this.patient.user.contact_detail.contatto_indirizzo = data.user.contact_detail.contatto_indirizzo;
      this.patient.id_stato_matrimoniale = data.id_stato_matrimoniale;
      this.patient.user.contact_detail.contatto_telefono = data.user.contact_detail.contatto_telefono;
      this.patient.links = data.links;
      localStorage.setItem('patient', JSON.stringify(this.patient))
    },

    fetchFiles: async function () {

      const fileSet = await getFiles();
      this.patient.tbl_files = fileSet;
      localStorage.setItem('patient', JSON.stringify(this.patient))
    },

    fetchKardias: async function () {

      const kardiaSet = await getKardias();
      this.patient.kardias = kardiaSet;
      localStorage.setItem('patient', JSON.stringify(this.patient))
    },
    fetchTaccuinos: async function () {

      const response = await getTaccuino(this.patient.id_paziente);


      this.patient.tbl_taccuinos = response.data

      localStorage.setItem('patient', JSON.stringify(this.patient))
    },


    fetchDownloadUrl: async function (id: number) {
      const url = await getUrl(id);
      return url;
    },

    fetchEsami: async function () {
      const esami = await getEsamiType(3);
      this.patient.esami = esami;
      localStorage.setItem('patient', JSON.stringify(this.patient))
    },

    fetchVaccini: async function () {
      const vaccini = await getVaccini();
      this.patient.tbl_vaccinaziones = vaccini;
      localStorage.setItem('patient', JSON.stringify(this.patient))
    },

    fetchCentri: async function () {
      this.patient.centri_convenzionati_laboratory_analisi = await getCentriIndagini(3);
      this.patient.centri_convenzionati_radiologici = await getCentriIndagini(2);
      this.patient.centri_convenzionati_specialistici = await getCentriIndagini(1);
      localStorage.setItem('patient', JSON.stringify(this.patient))
    },



    fetchFarmaci: async function () {
      this.patient.tbl_terapie = await getFarmaci(this.patient.id_paziente, 3);
      localStorage.setItem('patient', JSON.stringify(this.patient))
    },

    fetchAssociatedDoctors: async function () {
      this.patient.associated_doctors = await getAscDoctors(this.patient.id_paziente);
      // this.patient.associated_doctors = this.patient.associated_doctors.filter(doctor => doctor.active === 1);

      localStorage.setItem('patient', JSON.stringify(this.patient))
    },

    fetchNotAssociatedDoctors: async function () {
      this.patient.avalailable_doctors = await getNAdoctors(this.patient.id_paziente);
      //this.patient.avalailable_doctors = this.patient.avalailable_doctors.filter(doctor => doctor.active === 1);

      localStorage.setItem('patient', JSON.stringify(this.patient))
    },


    fetchLink: async function () {
      this.patient.links = await getLinkPersonale(this.patient.id_paziente);
     
    },


    fetchAdverseReaction: async function () {
      this.patient.adverse_reactions = await getAdverseReaction();
      localStorage.setItem('patient', JSON.stringify(this.patient))
    },

    fetchSecuritySettings: async function () {
      this.patient.loginLogs = await fetchSecuritySettings();
      localStorage.setItem('patient', JSON.stringify(this.patient));
    },


    fetchDiagnosi: async function () {

      const response = await fetchDiagnosi(this.patient.id_paziente);
      this.patient.diagnosi = response.data
      localStorage.setItem('patient', JSON.stringify(this.patient))


    },


    fetchVisite: async function () {
      const response = await fetchVisite(this.patient.id_paziente);
      this.patient.visite = response.data
      localStorage.setItem('patient', JSON.stringify(this.patient))
    },

    fetchRilevazioni: async function () {
      const response = await fetchRilevazioni(this.patient.id_paziente);
      this.patient.tbl_parametri_vitalis = response.data
      localStorage.setItem('patient', JSON.stringify(this.patient))
    },

    fetchEmergencyContact: async function () {
      const response = await getEmergencyContact(this.patient.id_paziente);
      this.patient.contattiemergenza = response.data
      localStorage.setItem('patient', JSON.stringify(this.patient))
    },

    fetchMoreContacts: async function () {
      const response = await getMoreContacts(this.patient.id_paziente);
      this.patient.contattialtro = response.data
      localStorage.setItem('patient', JSON.stringify(this.patient))
    },

    fetchHasBledScoresRelatedData: async function () {
      const hasBledScores = await getFilteredTypePatientScores(this.patient.id_paziente, 'has-bled-score');
      const hasBledScoreList = await getFilteredListScore('has-bled');
      const hasBledCombinationList = await getFilteredCombinationList('has-bled');
      this.hasBledScoreList = hasBledScoreList;
      this.hasBledScores = hasBledScores;
      this.hasBledCombinationList = hasBledCombinationList;
      localStorage.setItem('patient', JSON.stringify(this.patient))

    },

    fetchCha2Ds2ScoresRelatedData: async function () {
      const cha2ds2Scores = await getFilteredTypePatientScores(this.patient.id_paziente, 'cha2-ds2-score');
      const cha2ds2ScoreList = await getFilteredListScore('cha2ds2');
      const cha2ds2CombinationList = await getFilteredCombinationList('cha2ds2');
      this.cha2ds2ScoreList = cha2ds2ScoreList;
      this.cha2ds2Scores = cha2ds2Scores;
      this.cha2ds2CombinationList = cha2ds2CombinationList;
      localStorage.setItem('patient', JSON.stringify(this.patient))

    },

    fetchAnamnesiFm: async function () {

      const response = await fetchAnamnesiFm(this.patient.id_paziente);
      this.patient.tbl_anamnesi_familiare = response.data
      localStorage.setItem('patient', JSON.stringify(this.patient))


    },
    fetchAnamnesiFisiologica: async function () {

      const response = await fetchAnamnesiFisiologica(this.patient.id_paziente);
      this.patient.tbl_anamnesi_fisiologica = response.data
      localStorage.setItem('patient', JSON.stringify(this.patient))

    },
    fetchAnamnesiRm: async function () {

      const response = await fetchAnamnesiRm(this.patient.id_paziente);
      this.patient.tbl_anamnesi_pt_remota = response.data
      localStorage.setItem('patient', JSON.stringify(this.patient))

    },
    fetchAnamnesiPr: async function () {

      const response = await fetchAnamnesiPr(this.patient.id_paziente);
      this.patient.tbl_anamnesi_pt_prossima = response.data
      localStorage.setItem('patient', JSON.stringify(this.patient))

    },
    fetchGravidanze: async function () {

      const response = await fetchGravidanze(this.patient.id_paziente);
      this.patient.tbl_gravidanze = response;
      localStorage.setItem('patient', JSON.stringify(this.patient))
    },



    fetchMeldScoresRelatedData: async function () {
      const meldScores = await getFilteredTypePatientScores(this.patient.id_paziente, 'meld-score');
      const meldScoreList = await getFilteredListScore('meld');
      const meldCombinationList = await getFilteredCombinationList('meld');
      this.meldScoreList = meldScoreList;
      this.meldScores = meldScores;
      this.meldCombinationList = meldCombinationList;
      localStorage.setItem('patient', JSON.stringify(this.patient))
    },
    fetchFraminghamScoresRelatedData: async function () {
      const framinghamScores = await getFilteredTypePatientScores(this.patient.id_paziente, 'framingham-risk-score');
      const framinghamScoreList = await getFilteredListScore('framingham');
      this.framinghamScoreList = framinghamScoreList;
      this.framinghamScores = framinghamScores;
      localStorage.setItem('patient', JSON.stringify(this.patient))
    },
    fetchCardiovascolareRelatedData: async function () {
      const cardiovascolareScores = await getFilteredTypePatientScores(this.patient.id_paziente, 'cardiovascolare-score');
      const cardiovascolareScoreList = await getFilteredListScore('cardiovascolare');
      this.cardiovascolareScoreList = cardiovascolareScoreList;
      this.cardiovascolareScores = cardiovascolareScores;
      localStorage.setItem('patient', JSON.stringify(this.patient))
    },

    saveSchedaPaziente: async function () {
      this.patient.page = '';
      const response = await savePatient(this.patient);
      localStorage.setItem('patient', JSON.stringify(this.patient))

    },

    savePaziente: async function (page: string, id: number) {
      this.patient.id_update = id;
      this.patient.page = page;
      const response = await savePatient(this.patient);
      localStorage.setItem('patient', JSON.stringify(this.patient))

    },
    saveFarmaci: async function () {
      const response = await saveTerapia(this.patient);
      localStorage.setItem('patient', JSON.stringify(this.patient))
    },
    saveReaction: async function () {
      const response = await saveAdverseReaction(this.patient);
      localStorage.setItem('patient', JSON.stringify(this.patient))
    },
    updateConsenso: async function (consenso:Consensi,idConsenso:number) {
      const response = await updateConsenso(consenso,idConsenso);
      localStorage.setItem('patient', JSON.stringify(this.patient))

    }
  }
});

